import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import PhoneCaseForm from '../PhoneCaseForm/PhoneCaseForm';
import { PHONE_CASE_FORM_DEFAULT_VALUES } from '../PhoneCaseForm/constants';
import { useModals } from 'hooks/useModals';
import { TPhoneCasesAdd } from './PhoneCasesAdd.types';
import { useAppDispatch, useAppSelector } from 'store/store';
import {
  createPhoneCaseAsyncThunk,
  getPhoneCasesListAsyncThunk,
} from 'store/phoneCases/phoneCases.action';
import { TPhoneCaseFormValues } from '../PhoneCaseForm/PhoneCaseForm.types';
import { getPhoneCaseFormSchema } from '../PhoneCaseForm/PhoneCaseForm.schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { getLocalizationList } from 'store/localization/localization.action';
import { ESupportedLocales } from 'store/localization/localization.enums';

const PhoneCasesAdd: TPhoneCasesAdd = () => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();
  const modals = useModals();

  const { isLoading: isCreatePhoneCaseLoading } = useAppSelector(
    (store) => store.phoneCases.createPhoneCase
  );

  const phoneCaseFormSchema = React.useMemo(
    () => getPhoneCaseFormSchema(localize),
    [localize]
  );

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: PHONE_CASE_FORM_DEFAULT_VALUES,
    resolver: yupResolver(phoneCaseFormSchema),
    shouldUnregister: true,
  });

  const handleSubmit = (data: TPhoneCaseFormValues, images: File[]) => {
    dispatch(
      createPhoneCaseAsyncThunk({
        body: { ...data, images },
        onSuccess: () => {
          modals.closeModal();
          dispatch(getLocalizationList({ locale: ESupportedLocales.EN }));
          dispatch(
            getPhoneCasesListAsyncThunk({
              queryParams: { page: 1, perPage: 1000 },
            })
          );
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <PhoneCaseForm
        onSubmit={handleSubmit}
        isLoading={isCreatePhoneCaseLoading}
      />
    </FormProvider>
  );
};

export default PhoneCasesAdd;
